/**
 * Зацикленная анимация печатания "https://www" (02_GPT-MODULAR).
 */

import { useState } from "react";
import Typewriter from "../Typewriter/Typewriter";

// Компонент для зацикленной анимации печатания текста "https://www"
function CodeTypewriter() {
    const [phase, setPhase] = useState("typing");

    if (phase === "typing") {
        return (
            <Typewriter
                text="https://www"
                speed={100}
                delay={500}
                onComplete={() => {
                    setTimeout(() => setPhase("erasing"), 2000); // Пауза перед стиранием
                }}
            />
        );
    }

    return (
        <Typewriter
            reverse
            fullText="https://www"
            targetText=""
            speed={80}
            delay={300}
            onComplete={() => {
                setTimeout(() => setPhase("typing"), 500); // Пауза перед началом печатания
            }}
        />
    );
}

export default CodeTypewriter;
// components/CodeTypewriter/CodeTypewriter.js
